import { getCmsTermsOfUseActon } from "../../../Actions/LogicActions/TermsOfUse/GetCmsTermsOfUseActon";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { touTree } from "../../../Orchestrator/ConstantTree";

class TermsOfUseInitStep extends StepFlow {
    get stepName() { return "TermsOfUseInit_Step"; }

    async onEventSetup(): Promise<void> {
        this.registerEventSubscription(
            _eventBus.on<void, void>({
                eventName: touTree.Content.Get,
                handler: async () => {
                    await getCmsTermsOfUseActon.execute()
                },
            })
        );
    }

    async onExecute(): Promise<void> {
        console.log("TermsOfUse Init Step Execute...")

        // Execute the action to fetch CMS Terms of Use
        _eventBus.emit({
            eventName: touTree.Content.Get,
        });
    }
}

export const TermsOfUseInitStepDeclaration = new StepDefinition({
    stepName: "TermsOfUseInit_Step",
    stepClass: TermsOfUseInitStep
});